<dx-popup
  [width]="790"
  [height]="720"
  [showTitle]="true"
  class="fields-intervention-report-popup"
  [title]="title"
  [resizeEnabled]="true"
  [dragEnabled]="true"
  [closeOnOutsideClick]="false"
  [elementAttr]="{ class: 'fields-intervention-report-popup' }"
  (onHidden)="closed($event)"
  (onShowing)="onShowing($event)"
  (onShown)="onShown($event)"
  [(visible)]="visible"
>
  <div *dxTemplate="let data of 'content'">
    <dx-tabs
      [elementAttr]="{ class: 'fields-interventions-report-tabs' }"
      [dataSource]="tabs"
      [(selectedIndex)]="selectedIndex"
      (onItemClick)="selectTab($event)"
    ></dx-tabs>
    <app-fields-interventions-metrics
      *ngIf="intervention"
      [hidden]="selectedIndex !== 0"
      [intervention]="intervention"
    ></app-fields-interventions-metrics>
    <app-fields-interventions-map
      *ngIf="intervention"
      [intervention]="intervention"
      [hidden]="selectedIndex !== 1"
      [closed]="closed$"
    ></app-fields-interventions-map>
  </div>
</dx-popup>

<dx-load-panel
  shadingColor="rgba(0,0,0,0.1)"
  [position]="{ of: '.fields-intervention-report-popup' }"
  [visible]="loadingVisible"
  [showIndicator]="true"
  [showPane]="false"
  [shading]="true"
  [closeOnOutsideClick]="false"
>
</dx-load-panel>
